const activeLocks = new WeakMap();

export const lockDocumentScroll = ({
  documentElement = document.documentElement,
  body = document.body,
  windowObject = window,
} = {}) => {
  if (!documentElement || !body) return () => {};

  const existing = activeLocks.get(body);
  if (existing) return existing.acquire();

  const x = windowObject.scrollX || 0;
  const y = windowObject.scrollY || 0;
  const scrollbarWidth = Math.max(
    0,
    (windowObject.innerWidth || documentElement.clientWidth || 0) -
      (documentElement.clientWidth || 0),
  );
  const computedPaddingRight = Number.parseFloat(
    windowObject.getComputedStyle?.(body)?.paddingRight || "0",
  ) || 0;
  const documentStyles = {
    overflow: documentElement.style.overflow,
    overscrollBehavior: documentElement.style.overscrollBehavior,
  };
  const bodyStyles = {
    position: body.style.position,
    top: body.style.top,
    left: body.style.left,
    right: body.style.right,
    width: body.style.width,
    overflow: body.style.overflow,
    overscrollBehavior: body.style.overscrollBehavior,
    paddingRight: body.style.paddingRight,
    boxSizing: body.style.boxSizing,
  };

  documentElement.style.overflow = "hidden";
  documentElement.style.overscrollBehavior = "none";
  body.style.position = "fixed";
  body.style.top = `-${y}px`;
  body.style.left = `-${x}px`;
  body.style.right = "0";
  body.style.width = "100%";
  body.style.overflow = "hidden";
  body.style.overscrollBehavior = "none";
  body.style.paddingRight = `${computedPaddingRight + scrollbarWidth}px`;
  body.style.boxSizing = "border-box";

  const restore = () => {
    documentElement.style.overflow = documentStyles.overflow;
    documentElement.style.overscrollBehavior = documentStyles.overscrollBehavior;
    body.style.position = bodyStyles.position;
    body.style.top = bodyStyles.top;
    body.style.left = bodyStyles.left;
    body.style.right = bodyStyles.right;
    body.style.width = bodyStyles.width;
    body.style.overflow = bodyStyles.overflow;
    body.style.overscrollBehavior = bodyStyles.overscrollBehavior;
    body.style.paddingRight = bodyStyles.paddingRight;
    body.style.boxSizing = bodyStyles.boxSizing;
    if (x !== 0 || y !== 0) {
      windowObject.scrollTo?.(x, y);
    }
  };

  // Chat and login overlays may unmount in either order at a breakpoint.
  // Restore the original document only after the last owner releases it.
  let owners = 0;
  const acquire = () => {
    owners += 1;
    let released = false;
    return () => {
      if (released) return;
      released = true;
      owners -= 1;
      if (owners === 0) {
        activeLocks.delete(body);
        restore();
      }
    };
  };
  activeLocks.set(body, { acquire });
  return acquire();
};
